export default __webpack_public_path__ + "static/media/Resume.525c20d7.pdf";